import images from "./images";

const wines = [
  {
    title: "Chapel Hill Shiraz",
    price: "$56",
    tags: "AU | Bottle",
  },
  {
    title: "Catena Malbec",
    price: "$59",
    tags: "AR | Bottle",
  },
  {
    title: "La Vieille Rosé",
    price: "$44",
    tags: "FR | 750 ml",
  },
  {
    title: "Rhino Pale Ale",
    price: "$31",
    tags: "CA | 750 ml",
  },
  {
    title: "Irish Guinness",
    price: "$26",
    tags: "IE | 750 ml",
  },
];

const cocktails = [
  {
    title: "Aperol Spritz",
    price: "$20",
    tags: "Aperol | Villa Marchesi prosecco | Soda | 30 ml",
  },
  {
    title: "Dark 'N' Stormy",
    price: "$16",
    tags: "Dark rum | Ginger beer | Lime",
  },
  {
    title: "Daiquiri",
    price: "$10",
    tags: "Rum | Citrus juice | Sugar",
  },
  {
    title: "Old Fashioned",
    price: "$31",
    tags: "Bourbon | Brown sugar | Angostura bitters",
  },
  {
    title: "Negroni",
    price: "$26",
    tags: "Gin | Sweet vermouth | Campari | Orange garnish",
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: "Bib Gourmand",
    subtitle: "Awarded for exceptional food at moderate prices.",
  },
  {
    imgUrl: images.award01,
    title: "Rising Star",
    subtitle: "Recognized for outstanding innovation and future potential.",
  },
  {
    imgUrl: images.award05,
    title: "AA Hospitality Award",
    subtitle: "Honored for excellence in hospitality and service.",
  },
  {
    imgUrl: images.award03,
    title: "Outstanding Chef",
    subtitle: "Celebrating culinary leadership and creativity in the kitchen.",
  },
];

export default { wines, cocktails, awards };
